import { IsInPortrait, TogglePanelFor } from "../../state/selectors";
import { TopBarControl } from "../StyledControl";
import { text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { MousedOverTextHelper } from "../../state/uiAtoms";

function FilesControl() {
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const togglePanelFor = useSetRecoilState(TogglePanelFor);
	const handleClick = () => {
		togglePanelFor("files");
	};

	const mouseOver = () => {
		setTextHelper(text.controls.files);
	};

	const mouseLeave = () => {
		setTextHelper(undefined);
	};

	return (
		<TopBarControl
			$isInPortrait={isInPortrait}
			id="action-control-files"
			data-testid="files-control"
			onClick={handleClick}
			onMouseOver={mouseOver}
			onMouseLeave={mouseLeave}
			aria-label={text.controls.files}
		>
			{text.controls.files}
		</TopBarControl>
	);
}

export default FilesControl;
